import { Employee } from '../employees/employees.model';
import { DesignationEnum } from '../common/models/common.model';

export type Credentials = {
  email: string;
  password: string;
  client_type: string;
};

export type LoginResponse = {
  refresh: string;
  access: string;
};

/** ROTATE_REFRESH_TOKENS is on server-side, so a refresh also returns the next refresh token. */
export type RefreshResponse = {
  access: string;
  refresh?: string;
};

export type User = {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  role: string;
  profile_picture: string | null;
  phone_number: string;
  date_of_birth: string | null;
  address_line1: string;
  address_line2: string;
  postal_code: string;
  city: string;
  country: string;
  is_active: boolean;
  is_staff: boolean;
  created_by: number | null;
  employee: {
    id: string;
    employee_number: string;
    designation: { id: number; title: DesignationEnum } | null;
    date_of_joining: string;
  } | null;
  aadhar_card_number: string | null;
};

export interface ResetPasswordReqBody {
  new_password: string;
  current_password: string;
}

/** Server error codes carried on a 401. Same status, different meaning, so branch on the code. */
export const AuthErrorCode = {
  /** Access token merely expired. Refresh and retry; the user sees nothing. */
  TOKEN_NOT_VALID: 'token_not_valid',
  /** The account signed in elsewhere. Refreshing cannot recover this session. */
  SESSION_SUPERSEDED: 'session_superseded',
} as const;

export type SessionEndReason = (typeof AuthErrorCode)[keyof typeof AuthErrorCode];

/** Survives the redirect to the login screen, which reads it once and explains itself. */
export const SESSION_END_REASON_KEY = 'session_end_reason';
